import { isNumber } from "lodash";
import RenderOddsVelkie from "./MatchDetail/RenderOddsVelkie";
import useHomeSelectionLogic from "../useLogic/useHomeSelectionLogic";
const SelectionHome = ({ object, matchOdds }) => {
  const {
    runner,
    position,
    localLimit,
    handelChange,
    checkArrays,
    betSlipObject,
    showBetDialog,
  } = useHomeSelectionLogic({ object, matchOdds });
  return (
    <div className="relative">
      <div className="space-y-px">
        {runner?.map((item, index) => {
          const odds_back = matchOdds?.rt?.filter(
            (rt) => rt.ib && rt.ri === item.SelectionId
          );
          const odds_lay = matchOdds?.rt?.filter(
            (todd) => todd.ri === item.SelectionId && !todd.ib
          );
          const old_back = matchOdds?.rt?.filter(
            (todd) => todd.ib && todd.ri === item.SelectionId
          );
          const old_lay = matchOdds?.rt?.filter(
            (todd) => !todd.ib && todd.ri === item.SelectionId
          );
          let disabelBack = "lockBackBets" in item ? item?.lockBackBets : false;
          let disabelLay = "lockLayBets" in item ? item?.lockLayBets : false;
          let disableFull = checkArrays(
            odds_back?.slice(0, 1),
            odds_lay?.slice(0, 1),
            localLimit
          );
          let showPosition =
            (position?.betFair?.length > 0 && Math.abs(item?.position) > 0) ||
            (Math.abs(item?.newPosition) >= 0 &&
              showBetDialog &&
              betSlipObject?.playType == "home" &&
              object?.marketId == betSlipObject?.object?.newMarketId);
          return (
            <div className="match_odds_line">
              <div className="flex justify-between bg-black-100">
                <h2 className="px-2 w-9/12 flex flex-col justify-center break-all">
                  {item?.RunnerName || item?.runnerName}
                  {showPosition && (
                    <div
                      className="text-10 leading-normal flex"
                      data-testid="forecast"
                    >
                      {" "}
                      {isNumber(item?.position) &&
                        position?.betFair?.length > 0 &&
                        Math.abs(item?.position) > 0 && (
                          <span
                            className={`flex items-center ${
                              item?.position > 0 ? "text-success" : "text-error"
                            } `}
                          >
                            {isNumber(item?.position) &&
                            Math.abs(item?.position) > 0
                              ? item?.position > 0
                                ? Math?.abs(item?.position).toFixed(2)
                                : `(${Math.abs(item?.position).toFixed(2)})`
                              : ""}
                          </span>
                        )}
                      {Math.abs(item?.newPosition) >= 0 &&
                        showBetDialog &&
                        betSlipObject?.playType == "home" &&
                        object?.marketId ==
                          betSlipObject?.object?.newMarketId && (
                          <span
                            className={`flex items-center ${
                              item?.newPosition > 0
                                ? "text-success"
                                : "text-error"
                            } `}
                          >
                            <div className="icon-arrow-left rotate-180 flex text-6 mx-0.5" />{" "}
                            {item?.newPosition > 0
                              ? Math.abs(item?.newPosition).toFixed(2)
                              : `(${Math.abs(item?.newPosition).toFixed(2)})`}
                          </span>
                        )}
                    </div>
                  )}
                </h2>
                <RenderOddsVelkie
                  component={"betfair"}
                  index={index}
                  item={item}
                  disabelBack={disabelBack}
                  oldBack={old_back}
                  oldLay={old_lay}
                  disableFull={disableFull}
                  disabelLay={object?.market == "Win" ? true : disabelLay}
                  isInPlay={
                    ["Win", "Winner"].includes(object?.market)
                      ? true
                      : object?.status == "in_play"
                      ? true
                      : false
                  }
                  handelChange={handelChange}
                  odds_lay={odds_lay}
                  odds_back={odds_back}
                  limit={localLimit}
                  ms={matchOdds?.ms || 3}
                  betType={betSlipObject?.betType}
                  active={
                    showBetDialog &&
                    object?.marketId == betSlipObject?.newMarketId &&
                    item?.SelectionId == betSlipObject?.object?.SelectionId &&
                    "home" == betSlipObject?.playType
                  }
                />
              </div>
            </div>
          );
        })}
      </div>
      {matchOdds?.ms != 1 && (
        <div class="absolute right-0 top-0 flex justify-center items-center w-31% h-full bg-black-700 opacity-80 text-11 text-white rounded-md"></div>
      )}
    </div>
  );
};

export default SelectionHome;
